export default __webpack_public_path__ + "static/media/u-r-welcome.5c9cf375.gif";